import moment from "moment";
import { formateDate } from "./formats.js";

export function isValidCNPJ(value) {
    if (!value) return false;

    if (value === "00000000000000" || 
        value === "11111111111111" || 
        value === "22222222222222" || 
        value === "33333333333333" || 
        value === "44444444444444" || 
        value === "55555555555555" || 
        value === "66666666666666" || 
        value === "77777777777777" || 
        value === "88888888888888" || 
        value === "99999999999999")
        return false;

    // Remove caracteres não alfanuméricos e converte para maiúsculo
    value = value.toUpperCase().replace(/[^A-Z0-9]/g, '');

    if (value.length !== 14) return false;

    // Elimina CNPJs com todos os caracteres iguais
    if (/^(.)\1+$/.test(value)) return false;

    // Os dois últimos dígitos devem ser numéricos
    if (!/^[0-9]{2}$/.test(value.substring(12))) return false;

    // Cálculo validador utilizando a regra: valor = ASCII do caractere - 48
    const calc = (x) => {
        let factor = x - 7;
        let sum = 0;

        for (let i = 0; i < x; i++) {
            const charCode = value.charCodeAt(i);
            const n = charCode - 48;
            sum += n * factor--;
            if (factor < 2) factor = 9;
        }

        const result = 11 - (sum % 11);
        return result > 9 ? 0 : result;
    }

    const digit0 = calc(12);
    const digit1 = calc(13);

    return digit0 === parseInt(value[12]) && digit1 === parseInt(value[13]);
}

export function isValidCPF(cpf) {
    if (typeof cpf !== "string") return false
    cpf = cpf.replace(/[\s.-]*/igm, '')
    if (
        !cpf ||
        cpf.length !== 11 ||
        cpf === "00000000000" ||
        cpf === "11111111111" ||
        cpf === "22222222222" ||
        cpf === "33333333333" ||
        cpf === "44444444444" ||
        cpf === "55555555555" ||
        cpf === "66666666666" ||
        cpf === "77777777777" ||
        cpf === "88888888888" ||
        cpf === "99999999999" 
    ) 
        return false
    
    let soma = 0
    let resto
    for (let i = 1; i <= 9; i++) 
        soma = soma + parseInt(cpf.substring(i-1, i)) * (11 - i)
    resto = (soma * 10) % 11
    if ((resto === 10) || (resto === 11))  resto = 0
    if (resto !== parseInt(cpf.substring(9, 10)) ) return false
    soma = 0
    for (let i = 1; i <= 10; i++) 
        soma = soma + parseInt(cpf.substring(i-1, i)) * (12 - i)
    resto = (soma * 10) % 11
    if ((resto === 10) || (resto === 11))  resto = 0
    if (resto !== parseInt(cpf.substring(10, 11) ) ) return false
    return true
}

export function isValidDate(input_date){
    input_date = formateDate(input_date);
    var year = moment(input_date.toString(), "DD/MM/YYYY").year();

    if (year < 1000 || year > 3000)
        return false;

    return moment(input_date.toString(), "DD/MM/YYYY", true).isValid();
}

export function isValidDayMonth(input_date){
    return moment(input_date.toString(), "DD/MM", true).isValid();
}